import { useCallback, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';

export type SearchParamsUpdate = (previous: URLSearchParams) => URLSearchParams;

/**
 * A `setSearchParams` that stays correct however long the caller holds it. React Router
 * rebuilds the setter per render and hands the functional form *that render's* params,
 * so a callback armed before a ~100s poll writes back a snapshot taken at arm time and
 * wipes anything stamped into the URL since.
 */
export function useSearchParamsUpdater(): (update: SearchParamsUpdate) => void {
  const [, setSearchParams] = useSearchParams();
  const setSearchParamsRef = useRef(setSearchParams);

  useEffect(() => {
    setSearchParamsRef.current = setSearchParams;
  }, [setSearchParams]);

  return useCallback((update: SearchParamsUpdate) => {
    setSearchParamsRef.current(update, { replace: true });
  }, []);
}
